/* ==========================================================================
   Secrets d'Autrefois — page produit (sections sda-*)
   - changement de teinte : galerie, textes, prix, composition, URL
   - galerie : vignettes, glisser sur mobile, lecture des vidéos visibles
   - ajout au panier en AJAX, puis ouverture du panier du thème
   ========================================================================== */

(function () {
  if (window.SdaProduit) return;
  window.SdaProduit = true;

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split(".");
    var withSep = function (sep, dec) {
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (dec ? dec + parts[1] : "");
    };
    return (format || "{{amount_with_comma_separator}} €").replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case "amount": return withSep(",", ".");
        case "amount_no_decimals": return withSep(",", "");
        case "amount_with_comma_separator": return withSep(".", ",");
        case "amount_no_decimals_with_comma_separator": return withSep(".", "");
        case "amount_with_space_separator": return withSep(" ", ",");
        case "amount_with_apostrophe_separator": return withSep("'", ".");
        default: return withSep(" ", ",");
      }
    });
  }

  /* ---------------- Galerie ---------------- */

  function initGallery(gallery) {
    var track = gallery.querySelector(".sda-gallery__track");
    var slides = Array.prototype.slice.call(gallery.querySelectorAll(".sda-gallery__slide"));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll(".sda-gallery__thumb"));
    var dots = Array.prototype.slice.call(gallery.querySelectorAll(".sda-gallery__dots span"));
    if (!track || !slides.length) return;

    function setCurrent(index) {
      thumbs.forEach(function (t, i) { t.setAttribute("aria-current", i === index ? "true" : "false"); });
      dots.forEach(function (d, i) { d.setAttribute("aria-current", i === index ? "true" : "false"); });
      slides.forEach(function (s, i) {
        var video = s.querySelector("video");
        if (video && i !== index) video.pause();
      });
      gallery._current = index;
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener("click", function () {
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: "smooth" });
        setCurrent(i);
      });
    });

    var ticking = false;
    track.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        if (index !== gallery._current) setCurrent(index);
        ticking = false;
      });
    }, { passive: true });

    gallery._reset = function () {
      track.scrollLeft = 0;
      setCurrent(0);
    };
    gallery._pause = function () {
      gallery.querySelectorAll("video").forEach(function (v) { v.pause(); });
    };
    setCurrent(0);
  }

  /* ---------------- Section principale ---------------- */

  function initMain(section) {
    var dataEl = section.querySelector("[data-sda-variants]");
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var variants = data.variants;
    var form = section.querySelector("[data-sda-form]");
    var idInput = form.querySelector('input[name="id"]');
    var submit = form.querySelector("[data-sda-submit]");
    var submitLabel = submit.querySelector("[data-sda-submit-label]");
    var errorEl = section.querySelector("[data-sda-error]");
    var qtyInput = form.querySelector('input[name="quantity"]');
    var galleries = Array.prototype.slice.call(section.querySelectorAll(".sda-gallery"));
    var bundleEl = data.bundle ? section.querySelector("[data-sda-bundle]") : null;
    var packs = bundleEl ? Array.prototype.slice.call(bundleEl.querySelectorAll("[data-sda-pack]")) : [];
    var mainSwatches = Array.prototype.slice.call(section.querySelectorAll(".sda-swatch")).filter(function (s) {
      return !s.closest("[data-sda-bundle]");
    });

    galleries.forEach(initGallery);

    // Étoiles : défilement doux jusqu'aux avis
    var ratingLink = section.querySelector(".sda-rating");
    if (ratingLink) {
      ratingLink.addEventListener("click", function (e) {
        var target = document.querySelector(ratingLink.getAttribute("href"));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }

    function toArray(list) { return Array.prototype.slice.call(list); }

    function findVariant(id) {
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i];
      return null;
    }

    function setText(selector, value, root) {
      (root || section).querySelectorAll(selector).forEach(function (el) { el.textContent = value || ""; });
    }

    function money(cents) { return formatMoney(cents, data.moneyFormat); }

    function checkSwatch(list, variantId) {
      toArray(list.querySelectorAll(".sda-swatch")).forEach(function (s) {
        var active = String(s.dataset.variantId) === String(variantId);
        s.setAttribute("aria-checked", active ? "true" : "false");
        s.tabIndex = active ? 0 : -1;
      });
    }

    /* Affichage d'une teinte : galerie, textes, FAQ, URL */
    function showVariant(variant, updateUrl) {
      if (!variant) return;
      idInput.value = variant.id;
      mainSwatches.forEach(function (s) {
        var active = String(s.dataset.variantId) === String(variant.id);
        s.setAttribute("aria-checked", active ? "true" : "false");
        s.tabIndex = active ? 0 : -1;
      });

      setText("[data-sda-shade-name]", variant.teinte);
      setText("[data-sda-accroche]", variant.accroche);
      setText("[data-sda-price]", money(variant.price));
      setText("[data-sda-unit-price]", variant.unit_price_label);

      galleries.forEach(function (g) {
        var match = String(g.dataset.variantId) === String(variant.id);
        if (match && g.hidden) {
          g.hidden = false;
          if (g._reset) g._reset();
        } else if (!match && !g.hidden) {
          g.hidden = true;
          if (g._pause) g._pause();
        }
      });

      // Composition dans la FAQ (autre section de la page)
      setText("[data-sda-composition-shade]", variant.teinte, document);
      document.querySelectorAll("[data-sda-composition-body]").forEach(function (el) {
        el.textContent = variant.composition || "";
      });

      if (updateUrl) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url.toString());
      }

      document.dispatchEvent(new CustomEvent("sda:variant-change", { detail: { variant: variant } }));
    }

    /* ---------------- Packs ---------------- */

    function activePack() {
      for (var i = 0; i < packs.length; i++) if (packs[i].hasAttribute("data-selected")) return packs[i];
      return packs[0];
    }

    function slotVariants(pack) {
      return toArray(pack.querySelectorAll("[data-sda-slot]")).map(function (slot) {
        var checked = slot.querySelector('.sda-swatch[aria-checked="true"]');
        return findVariant(checked ? checked.dataset.variantId : idInput.value);
      });
    }

    // Prix du pack : doit refléter les réductions automatiques Shopify
    function packTotals(pack) {
      var list = slotVariants(pack);
      var full = list.reduce(function (sum, v) { return sum + (v ? v.price : 0); }, 0);
      var n = list.length;
      var total = full;
      if (n === 2) total = full - 2 * (data.pack2AmountOff || 0);
      if (n >= 3) total = Math.round(full * (100 - (data.pack3Percent || 0)) / 100);
      return { full: full, total: Math.max(0, total), variants: list };
    }

    function refreshBuy() {
      var total, available;
      if (bundleEl) {
        packs.forEach(function (pack) {
          var t = packTotals(pack);
          setText("[data-sda-pack-price]", money(t.total), pack);
          pack.querySelectorAll("[data-sda-pack-compare]").forEach(function (el) {
            el.textContent = money(t.full);
            el.hidden = t.total >= t.full;
          });
        });
        var current = packTotals(activePack());
        total = current.total;
        available = current.variants.every(function (v) { return v && v.available; });
      } else {
        var v = findVariant(idInput.value);
        var qty = parseInt(qtyInput.value, 10) || 1;
        total = v ? v.price * qty : 0;
        available = v && v.available;
      }
      submit.disabled = !available;
      submitLabel.textContent = available ? data.labels.add + " — " + money(total) : data.labels.soldOut;
    }

    function selectPack(pack) {
      var previous = activePack();
      var previousIds = slotVariants(previous).map(function (v) { return v && v.id; });
      packs.forEach(function (p) {
        var selected = p === pack;
        p.toggleAttribute("data-selected", selected);
        p.querySelector(".sda-pack__radio").checked = selected;
        p.querySelector("[data-sda-pack-slots]").hidden = !selected;
      });
      // Garder les teintes déjà choisies pour les huiles communes aux deux packs
      if (previous !== pack) {
        toArray(pack.querySelectorAll("[data-sda-slot]")).forEach(function (slot, i) {
          if (!previousIds[i]) return;
          setSlot(slot, findVariant(previousIds[i]));
        });
      }
      var first = slotVariants(pack)[0];
      showVariant(first, false);
      refreshBuy();
    }

    function setSlot(slot, variant) {
      if (!variant) return;
      checkSwatch(slot, variant.id);
      setText("[data-sda-slot-name]", variant.teinte, slot);
    }

    packs.forEach(function (pack) {
      pack.querySelector(".sda-pack__radio").addEventListener("change", function () { selectPack(pack); });
      toArray(pack.querySelectorAll("[data-sda-slot]")).forEach(function (slot) {
        toArray(slot.querySelectorAll(".sda-swatch")).forEach(function (swatch) {
          swatch.addEventListener("click", function () {
            var variant = findVariant(swatch.dataset.variantId);
            setSlot(slot, variant);
            showVariant(variant, true);
            refreshBuy();
          });
        });
      });
    });

    /* ---------------- Pastilles hors packs ---------------- */

    mainSwatches.forEach(function (swatch) {
      swatch.addEventListener("click", function () {
        showVariant(findVariant(swatch.dataset.variantId), true);
        refreshBuy();
      });
    });

    // Navigation au clavier dans chaque groupe de pastilles
    section.querySelectorAll(".sda-swatches__list").forEach(function (group) {
      var items = toArray(group.querySelectorAll(".sda-swatch"));
      items.forEach(function (swatch, i) {
        swatch.addEventListener("keydown", function (e) {
          var dir = e.key === "ArrowRight" || e.key === "ArrowDown" ? 1 : e.key === "ArrowLeft" || e.key === "ArrowUp" ? -1 : 0;
          if (!dir) return;
          e.preventDefault();
          var next = items[(i + dir + items.length) % items.length];
          next.focus();
          next.click();
        });
      });
    });

    /* ---------------- Quantité ---------------- */

    section.querySelectorAll("[data-sda-qty]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var value = (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.dataset.sdaQty, 10);
        qtyInput.value = Math.max(1, value);
        qtyInput.dispatchEvent(new Event("change"));
      });
    });
    qtyInput.addEventListener("change", function () {
      if ((parseInt(qtyInput.value, 10) || 0) < 1) qtyInput.value = 1;
      refreshBuy();
    });

    /* ---------------- Ajout au panier ---------------- */

    function cartItems() {
      if (!bundleEl) {
        return [{ id: Number(idInput.value), quantity: parseInt(qtyInput.value, 10) || 1 }];
      }
      // Regrouper les huiles de même teinte sur une seule ligne
      var byId = {};
      var order = [];
      slotVariants(activePack()).forEach(function (v) {
        if (!v) return;
        if (!byId[v.id]) { byId[v.id] = 0; order.push(v.id); }
        byId[v.id] += 1;
      });
      return order.map(function (id) { return { id: Number(id), quantity: byId[id] }; });
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (submit.disabled) return;
      errorEl.textContent = "";
      submit.setAttribute("aria-busy", "true");
      submit.disabled = true;

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      fetch(root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: cartItems() })
      })
        .then(function (res) {
          return res.json().then(function (json) {
            if (!res.ok) throw new Error(json.description || json.message || data.labels.error);
            return json;
          });
        })
        .then(function () {
          // Le thème Stiletto rafraîchit son panier et le compteur sur cet événement
          document.dispatchEvent(new CustomEvent("apps:product-added-to-cart"));
          var cartIcon = document.querySelector("[data-js-cart-icon]");
          if (cartIcon && document.querySelector(".quick-cart")) {
            setTimeout(function () { cartIcon.click(); }, 350);
          } else {
            window.location.href = root + "cart";
          }
        })
        .catch(function (err) {
          errorEl.textContent = err.message || data.labels.error;
        })
        .finally(function () {
          submit.removeAttribute("aria-busy");
          refreshBuy();
        });
    });

    showVariant(findVariant(idInput.value) || variants[0], false);
    refreshBuy();
  }

  /* ---------------- Vidéos : lecture seulement à l'écran ----------------
     Les vidéos sont rendues sans autoplay et avec preload="none" : rien n'est
     chargé tant qu'elles ne sont pas visibles. Safari iOS limite fortement la
     mémoire d'une page ; trop de vidéos préparées d'un coup empêchait l'affichage
     d'autres éléments (cadre des avis Loox). */

  var videoObserver = null;

  function playVideo(video) {
    video.muted = true;
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  function observeVideos(root) {
    var videos = (root || document).querySelectorAll("video[data-sda-video]");
    if (!("IntersectionObserver" in window)) {
      videos.forEach(playVideo);
      return;
    }
    if (!videoObserver) {
      videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.35 && !video.closest("[hidden]")) {
            playVideo(video);
          } else if (!video.paused) {
            video.pause();
          }
        });
      }, { threshold: [0, 0.35] });
    }
    videos.forEach(function (video) {
      if (video._sdaObserved) return;
      video._sdaObserved = true;
      videoObserver.observe(video);
    });
  }

  /* ---------------- Avis Loox : forcer l'affichage sur Safari iOS ----------------
     Sous forte charge mémoire, Safari iOS peut charger le cadre des avis sans le
     dessiner. On lui donne sa propre couche d'affichage et on force un redessin
     à chaque fois qu'il entre à l'écran. */

  function nudgeLoox() {
    var wrapper = document.getElementById("looxReviews");
    if (!wrapper || wrapper._sdaNudge || !("IntersectionObserver" in window)) return;
    wrapper._sdaNudge = true;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var frame = document.getElementById("looxReviewsFrame");
        if (!entry.isIntersecting || !frame) return;
        frame.style.transform = "translateZ(0)";
        frame.style.opacity = "0.99";
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { frame.style.opacity = ""; });
        });
      });
    }, { threshold: [0, 0.05] }).observe(wrapper);
  }

  function init(root) {
    observeVideos(root);
    nudgeLoox();
    (root || document).querySelectorAll("[data-sda-main]").forEach(function (section) {
      if (section._sdaReady) return;
      section._sdaReady = true;
      initMain(section);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(); });
  } else {
    init();
  }

  // Éditeur de thème : réinitialiser quand une section est rechargée
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
